module.exports = __webpack_public_path__ + "img/421e285e078d54e444004311af402df7.png";